import { useEffect, useState } from "react";
import Menu from "../../../../components/Menu/Menu";
import NotAuthenticated from "../../../../components/NotAuthenticated/NotAuthenticated";
import useAuth from "../../../../hooks/useAuth";
import api from "../../../../js/api";
import './PartyFun.scss';
import Button from "../../../../components/Button/Button";
import { useParams } from "react-router-dom";
import TeamSelector from "./TeamSelector";

export default function PartyFun() {

    const [room, setRoom] = useState('');
    const { roomNumber } = useParams();

    const [team1, setTeam1] = useState([]);
    const [team2, setTeam2] = useState([]);

    const hasTeams = team1.length > 0 && team2.length > 0;
    // const [game_data, setGame_data] = useState(null);

    useEffect(() => {
        api.get(`/rooms/${roomNumber}`).then((response) => {
            setRoom(response);
            console.log(response);
        })
    }, [])

    const authenticated = useAuth();
    if (authenticated === false) {
        return <NotAuthenticated />;
    }

    if (!hasTeams) {
        return <TeamSelector team1={team1} team2={team2} setTeam1={setTeam1} setTeam2={setTeam2} />;
    }

    if (!room) {
        return (
            <div>
                <h1>Loading Room...</h1>
            </div>
        )
    }

    if (room && room.error) {
        return (
            <div>
                <h1>Error: {room.error}</h1>
            </div>
        )
    }

    return (
        <div id='party-fun'>
            <div className='centered-container'>
                <h3>Room #{room.id}</h3>
                <div className="containers-wrapper">
                    <div className="background-red">
                    </div>
                    <div className="background-blue">
                    </div>
                </div>
                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    )
}